/// <reference path="../../typings/browser.d.ts" />

namespace Application.Models {
    'use strict';
    
    export interface ITsProbe {
        networkNodeId: number;
        networkNodeName: string;
        emptySlots: number;
        totalSlots: number;
        tsInputs: ITSIpAndPort[];
        error?: string;
        defaultProbe: boolean;
    }

    export interface ITSProbeInfo {
        blockId: number;
        blockName: string;
        hasAssignedProbe: boolean;
        assignedProbe: ITsProbe;
        assignedProbesFound: IFindByTsResults;
        hasLockedTSProbe: boolean;
        lockingTSProbe: boolean;
        probePermissions?: IEvaluatedAcl;
        slot?: number;
        style?: any;
        link?: string;
        tooltipText?: string;
    }

    export class TsProbe implements ITsProbe {
        public networkNodeId: number;
        public networkNodeName: string;
        public emptySlots: number;
        public totalSlots: number;
        public tsInputs: ITSIpAndPort[];
        public error?: string;
        public permissions?: Models.IEvaluatedAcl;
        public defaultProbe: boolean;
        public static Empty(): TsProbe {
            return new TsProbe();
        }

        public static Copy(probe: ITsProbe): TsProbe {
            let newTsProbe: TsProbe = new TsProbe();
            newTsProbe.networkNodeId = probe.networkNodeId;
            newTsProbe.networkNodeName = probe.networkNodeName;
            newTsProbe.emptySlots = probe.emptySlots;
            newTsProbe.totalSlots = probe.totalSlots;
            newTsProbe.tsInputs = probe.tsInputs;
            newTsProbe.error = probe.error;
            newTsProbe.defaultProbe = probe.defaultProbe;
            return newTsProbe;
        }

        constructor() {
            // empty constructor
        }
    }

    export interface ITsProbeFound {
        tsProbe: ITsProbe;
        slot: number;
        locked: boolean;
        defaultProbe: boolean;
    }

    export interface IFindByTsResults {
        tsProbesFound: ITsProbeFound[];
        defaultTsProbe: ITsProbeFound;
        selectedStream: ITSIpAndPort;
    }

    export interface ITSIpAndPort {
        ip: string;
        port: number;
    }

    export interface ITsProbeGui {
        guiUrl: string;
        apiUrl: string;
        absolute: boolean;
    }
        
    export interface ISelectableProbe {
        probe: Models.TsProbe;
        node: Models.NetworkNode;
    }

    export interface IAllProbedBlocks {
        allProbedBlocks: {[key: number]: Models.IFindByTsResults};
        probes: Models.TsProbe[];
    }

    export interface ITsChange {
        networkNodeId: number;
        defaultProbe: boolean;
    }

    export type BundleProbeJobStatus = "RUNNING" | "FINISHED" | "ERROR";

    export interface IBundleProbeJob {
        uuid: string;
        status: BundleProbeJobStatus
        results: ProbeOperationResult[];
        exception: string;
    }

    export interface ProbeOperationResult {
        result: boolean;
        message: string;
        errors: string[];
    }

}
